/*
 * Project: LegalPlace assistant
 * File: src\components\wizard_body.js
 * Author: Amine Azizi
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setRepriseWizard } from '../redux/actions/contract';
import LpSendInBluekOps from '../app/ops/sendinblue_notification';
import lpevents from "../tracking/lpevents";
import lpApp from '../app/lp_app';

class _RepriseWizard extends Component {
  constructor(props) {
    super(props);
    this.poursuivre = this.poursuivre.bind(this);
  }

  componentDidMount() {
    document.body.classList.add('wz-page');
    document.body.classList.add('step2-reprise');

    if (this.props.is_crea_assist_sub) {
      const sdbNotif = new LpSendInBluekOps();
      sdbNotif.sendInBlueNotification({}, this.props.is_crea_assist_sub);
    }

    document.getElementsByTagName('html')[0].style.fontSize = '10px';
  }

  componentWillUpdate() {
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    console.log(this.props.reprise_link);
    document.body.classList.remove('wz-page');
    document.body.classList.remove('step2-reprise');
    window.onbeforeunload = null;
    window.location.href = this.props.reprise_link;
  }

  poursuivre() {
    /*
     * Adwords Conversion tracking
     */
    if ([162, 144, 197, 175, 176, 124, 180].indexOf(lpApp.contractMetaId) > -1) {
      lpevents.adwordsConversion({
        google_conversion_value: 0.01
      });
    }
    this.props.setRepriseWizard(false);
  }

  render() {
    const styles = {
      cursor: 'pointer',
    };

    return (
      <article className="wz-container">
        <h1 className="has-ok-icn">Votre paiement a été validé !</h1>
        <p>Merci de répondre aux questions complémentaires afin de permettre à notre logiciel de créer les documents juridiques les plus adaptés à votre situation.</p>
        <a className="is-cta is-rounded has-arrow-right" onClick={this.poursuivre} style={styles}>Poursuivre</a>
      </article>
    );
  }
}

const mapStateToProps = state => ({
  currentSection: state.contract.currentSection,
  doc_state: state.document_state.state,
  reprise_wizard: state.contract.reprise_wizard,
  reprise_link: state.contract.reprise_link,
  is_crea_assist_sub: state.account_settings.is_crea_assist_sub,
});


const mapDispatchToProps = dispatch => ({
  setRepriseWizard: (val) => {
    dispatch(setRepriseWizard(val));
  },
});

const RepriseWizard = connect(mapStateToProps, mapDispatchToProps)(_RepriseWizard);

export default RepriseWizard;



// WEBPACK FOOTER //
// ./src/components/reprise_wizard.js